import { Fragment, FunctionComponent } from 'react';

import { $TabViewTransitionContainer } from './Tabs.styles';
import { Tab } from './Tabs.types';

interface TabsBodyProps {
  activeTab: Tab;
  tabs: Tab[];
  values?: Record<string, unknown>;
  withTransition: boolean;
}

const TabsBody: FunctionComponent<TabsBodyProps> = ({
  activeTab,
  tabs,
  values,
  withTransition,
}) => {
  if (!withTransition) {
    return (
      <>
        {tabs
          .filter((tab) => activeTab && activeTab.name === tab.name)
          .map(({ name, Component = undefined, children = undefined }) => {
            if (!children && !Component) {
              throw new Error(
                `[Tabs: ${name}] should have at least one children or a component`,
              );
            }

            return (
              <>{children || (Component && <Component values={values} />)}</>
            );
          })}
      </>
    );
  }

  return (
    <$TabViewTransitionContainer>
      {tabs
        .filter((tab) => activeTab && activeTab.name === tab.name)
        .map(({ name, Component = undefined, children = undefined }) => {
          if (!children && !Component) {
            throw new Error(
              `[Tabs: ${name}] should have at least one children or a component`,
            );
          }

          return (
            <Fragment key={name}>
              {children || (Component && <Component values={values} />)}
            </Fragment>
          );
        })}
    </$TabViewTransitionContainer>
  );
};

export default TabsBody;
